export const BASE_URL = 'https://lens-6ewaiah5tq-ue.a.run.app/v2';

export const BASE_URL_STATUS = 'https://lens-node-be-6ewaiah5tq-ue.a.run.app/v2';
